function scrollInsideElement(target, container, margin, axis) {
    if ($(target).length) {
        if (axis == "x") {
            var scrollLeft = $(target).offset().left - $(container).offset().left;
            var targetLeft = $(`${container} > *`).offset().left - $(container).offset().left;
            var scrollOffset = scrollLeft - targetLeft;
            $(container).scrollLeft(scrollOffset - margin);
        }
        else {
            var scrollTop = $(target).offset().top - $(container).offset().top;
            var targetTop = $(`${container} > *`).offset().top - $(container).offset().top;
            var scrollOffset = scrollTop - targetTop;
            $(container).scrollTop(scrollOffset - margin);
        }
    }
}
const validateEmail = (email) => {
    return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
function showOnline() {
    var cont = document.getElementById('profile-pic-div');
    cont.classList.remove('offline');
    cont.classList.add('online');
}
function showOffline() {
    var cont = document.getElementById('profile-pic-div');
    cont.classList.remove('online');
    cont.classList.add('offline');
}
function getDayName(dateString, shortDate = false) {
    //MM-dd-yyyy
    const daysInSpanish = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
    const shortDaysInSpanish = ["Dom", "Lu", "Mar", "Mie", "Jue", "Vie", "Sab"];

    const [month, day, year] = dateString.split('-');
    const date = new Date(Date.UTC(year, month - 1, day)); 

    const today = new Date();
    const todayYear = today.getFullYear();
    const todayMonth = String(today.getMonth() + 1).padStart(2, '0'); 
    const todayDay = String(today.getDate()).padStart(2, '0');

    if (dateString == `${todayMonth}-${todayDay}-${todayYear}`) {
        return "Hoy";
    }

    const dayIndex = date.getUTCDay();
    return shortDate ? shortDaysInSpanish[dayIndex] : daysInSpanish[dayIndex];
}
function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}
function openNewTab(URL) {
    window.open(URL, '_blank').focus();
}
function goTo(URL) {
    displayProgressBar();
    window.location.href = URL;
}
function copyToClipboard(text) {
    navigator.clipboard.writeText(text);
    showToast('Texto copiado', 'success',3000);
}
function getUrlParameters(url, parameter) {
    const searchParams = new URLSearchParams(url);
    return searchParams.get(parameter);
}
function removeUrlParam(url, parameter) {
    let urlObj = new URL(url);
    let params = new URLSearchParams(urlObj.search);
    params.delete(parameter); 
    urlObj.search = params.toString(); 
    return urlObj.toString(); 
}
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}
function validateMobileDevice() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return mobileRegex.test(userAgent);
}
function getAllOptionsFromSelectElement(selectElement) {
    const options = selectElement.options;
    for (let i = 0; i < options.length; i++) {
        const option = options[i];
    }
    const optionsArray = Array.from(options).map(option => ({
        text: option.text,
        value: option.value
    }));
    return optionsArray;
}
function scrollToDiv(element) {
    if (element) {
        let elementPosition = element.getBoundingClientRect().top + window.scrollY;
        let windowHeight = window.innerHeight;
        let offset = elementPosition - (windowHeight / 2) + (element.clientHeight / 2);

        window.scrollTo({
            top: offset,
            behavior: "smooth"
        });
    }
}
function isFullName(nombre) {
    const limpio = nombre.trim();
    if (limpio === "") return false;

    const partes = limpio.split(/\s+/);
    if (partes.length < 2) return false;

    const regex = /^[A-Za-zÁÉÍÓÚáéíóúÑñÜü'´`]{2,}$/;
    for (const parte of partes) {
        if (!regex.test(parte)) return false;
    }

    return true;
}
function parseDate(dateStr) {
    const [month, day, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day); 
}
function formatDate(date, format) {
    const mm = String(date.getMonth() + 1).padStart(2, '0'); 
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();

    switch (format) {
        case "yyyy-MM-dd":
            return `${yyyy}-${mm}-${dd}`;
        case "dd-MM-yyyy":
            return `${dd}-${mm}-${yyyy}`;
        case "MM-dd-yyyy":
            return `${mm}-${dd}-${yyyy}`;
        case "yyyy/MM/dd":
            return `${yyyy}/${mm}/${dd}`;
        case "dd/MM/yyyy":
            return `${dd}/${mm}/${yyyy}`;
        case "MM/dd/yyyy":
            return `${mm}/${dd}/${yyyy}`;
        case "dd-MM":
            return `${dd}-${mm}`;
        case "dd/MM":
            return `${dd}/${mm}`;
        case "MM-dd":
            return `${mm}-${dd}`;
        case "MM/dd":
            return `${mm}/${dd}`;
        case "dd":
            return `${dd}`;
        case "MM":
            return `${mm}`;
        case "yyyy":
            return `${yyyy}`;
    }
}
function formatCurrency(value, locale = 'en-US', currency = 'USD') {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value);
}